import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { getRecaptchaKey } from '../../store/actions';
import PropTypes from 'prop-types';

const ReCaptcha = (props) => {
    const { handleCaptchaValue } = props;
    let captcha = useRef(null);
    let [siteKey, setSiteKey] = useState('');
    const getUserRecaptchaKey = () => {
        getRecaptchaKey().then((res) => {
            setSiteKey(res.data.Entity)
        });
    };

    useEffect(() => {
        getUserRecaptchaKey();
    }, []);

    return (
        siteKey && (
            <ReCAPTCHA
                sitekey={siteKey}
                onChange={handleCaptchaValue}
                className="g-recaptcha"
                size="normal"
                theme="light"
                hl="en"
                ref={captcha}
            />
        )
    )
};

ReCaptcha.propTypes = {
    handleCaptchaValue: PropTypes.func.isRequired
};

export default ReCaptcha;